// @flow
import styled from 'styled-components';
import { media } from '../../index';
import IconBoxDefaultTheme from '../../icon-box/theme';
/*::
import type { Node } from 'react';
import type { StyledComponent } from 'styled-components';
import type { IconBoxThemeType } from '../../icon-box/theme';

export type MainType = {|
  children?: React$Element<any> | React$Element<any>[],
  rest?: any,
|}

export type IconBoxGridThemeType = {|
  Main: StyledComponent<MainType, mixed, HTMLDivElement>
    | React$ComponentType<MainType>,
  IconBoxLargeFixedHeight: IconBoxThemeType,
  IconBoxLargeWithText: IconBoxThemeType,
  IconBoxNarrowWithText: IconBoxThemeType,
  IconBoxMedium: IconBoxThemeType,
  IconBoxSmall: IconBoxThemeType,
|}
*/

var IconBoxGridTheme
/*: IconBoxGridThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "km3y8x-0"
  })(["display:flex;flex-wrap:wrap;justify-content:center;"]),
  IconBoxLargeFixedHeight: Object.assign({}, IconBoxDefaultTheme, {
    Main: styled(IconBoxDefaultTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "km3y8x-1"
    })(["margin:2.4rem;width:28rem;height:22.6rem;", "{width:22.8rem;height:21rem;}", "{width:14rem;height:12rem;}"], media.md, media.sm),
    Label: styled(IconBoxDefaultTheme.Label).withConfig({
      displayName: "theme__Label",
      componentId: "km3y8x-2"
    })(["margin-top:2.4rem;", "{margin:1.6rem 0 0 0;font-size:1.3rem;}", "{line-height:1.8rem;}"], media.sm, media.sm),
    Icon: styled(IconBoxDefaultTheme.Icon).withConfig({
      displayName: "theme__Icon",
      componentId: "km3y8x-3"
    })(["height:8rem;", "{height:4.8rem;}"], media.sm)
  }),
  IconBoxLargeWithText: Object.assign({}, IconBoxDefaultTheme, {
    Main: styled(IconBoxDefaultTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "km3y8x-4"
    })(["margin:2.4rem;", "{width:100%;}"], media.sm)
  }),
  IconBoxNarrowWithText: Object.assign({}, IconBoxDefaultTheme, {
    Main: styled(IconBoxDefaultTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "km3y8x-5"
    })(["margin:2.4rem;width:27rem;", "{width:100%;}"], media.sm)
  }),
  IconBoxMedium: Object.assign({}, IconBoxDefaultTheme, {
    Main: styled(IconBoxDefaultTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "km3y8x-6"
    })(["margin:2.4rem;width:27rem;", "{width:100%;}"], media.sm)
  }),
  IconBoxSmall: Object.assign({}, IconBoxDefaultTheme, {
    Main: styled(IconBoxDefaultTheme.Main).withConfig({
      displayName: "theme__Main",
      componentId: "km3y8x-7"
    })(["margin:2.4rem;width:17rem;padding:1.5rem;"]),
    Label: styled(IconBoxDefaultTheme.Label).withConfig({
      displayName: "theme__Label",
      componentId: "km3y8x-8"
    })(["margin-top:1rem;"]),
    Icon: styled(IconBoxDefaultTheme.Icon).withConfig({
      displayName: "theme__Icon",
      componentId: "km3y8x-9"
    })(["height:4rem;"])
  })
};
export default IconBoxGridTheme;